import { useQuery } from '@tanstack/react-query';
import { useApi, useAuth } from '../../hooks';
import type { ProviderTask } from '../../models/providerHome';

export const useProviderTasks = () => {
  const { api } = useApi();
  const { isAuthenticated, loading, userToken } = useAuth();

  const { data, isLoading, isError } = useQuery<ProviderTask[], Error>({
    queryKey: ['provider-home-tasks', userToken],
    queryFn: () =>
      api({ route: '/private/provider-home/tasks', token: userToken }),
    enabled: isAuthenticated && !loading && !!userToken,
    refetchOnWindowFocus: false,
  });

  return { tasks: data ?? [], isLoading, isError };
};
